
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Privacy = ({ title }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get('/api/legal/privacy')
      .then(res => setData(res.data))
      .catch(() => setData({ error: true }));
  }, []);

  if (!data) return <p>Loading...</p>;
  if (data.error) return <p>Unable to load Privacy Policy.</p>;

  return (
    <div className="main-content">
      <h2>{title}</h2>
      <small>Last Updated: {data.updated}</small>
      <div dangerouslySetInnerHTML={{ __html: data.content }} />
    </div>
  );
};

export default Privacy;
